import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;

export type TTicketStock = "PDF" | "HARD";

export const { thunk: editTicketStock, slice: editTicketStockSlice } = getThunkAndSlice<
	{
		ListingIds: Array<number>;
		TicketStock: TTicketStock;
	},
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/EditTicketStock",
	method: "post",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const isEDelivery = params.TicketStock === "PDF";
		const eventId = getInventoryCacheEventId(rootState);

		const newData = rootState.pricing.eventInventoryAll.data.map((item) => {
			if (!params.ListingIds.includes(item.Listing_ID)) return item;
			return { ...item, SH_eDelivery: isEDelivery };
		});
		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((item) => {
				if (!params.ListingIds.includes(item.Listing_ID)) return item;
				return { ...item, SH_eDelivery: isEDelivery };
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
